<template>
  <div :style="{height:height2,width:width}" style="height: 300px;overflow-y: scroll;overflow-x:scroll;position: relative;background-color: #ffffff;">
    <div style="position: sticky;left: 0;top: 0;z-index: 2;display: flex;flex-direction: row">
<!--      <el-button size="mini" @click="getData">刷新</el-button>-->
      <el-input
        placeholder="输入关键字进行过滤"
        size="mini"
        v-model="filterText">
      </el-input>
      <el-button size="mini" @click="closeComponent">{{height2!=='40px'?'关闭':'展开'}}</el-button>
    </div>

    <ZTree
      ref="ZTreeRef"
      v-if="treeDatas.length"
      :setting="setting"
      :node-data="treeDatas"
      :isCheck="isCheckbox"
      @onClick="onClick"
      @onCheck="onCheck"
    />
  </div>
</template>

<script>


import ZTree from "../../../../Common/ztree/ZTree";
import MeterHttp from "../../../common/MeterHttp";
export default {
  name: "MeterTreeComponent",
  components:{ZTree},
  props:{
    height:{type:String,default:()=>"300px"},
    width:{type:String,default:()=>"250px"},
    project_id:[Number,String],
    isCheckbox:{type:Boolean,default:()=>false},
    checked_keys:{type:String|Number,default:()=>''},
  },
  data(){
    return{
      //ztree配置，参照ztree官网的配置
      setting: {
        data: {
          simpleData: {
            //是否使用简单数据模式
            enable: true,
            //树节点id，一般是后台数据库主键
            idKey: "id",
            //父级id
            pIdKey: "pid",
            rootPId: "0"
          },
          key: {
            name: 'meter_name', //需要显示的字段名称
          },
        },
      },
      treeDatas:[],
      ztreeObj:null,
      tree:[],
      filterText:"",
      height2:0,
      _checkboxKeys:[],
    }
  },
  created() {
    const that=this;
    that.height2=that.height;
    that.getData();
  },
  methods:{
    getData(callback){
      const that=this;

      MeterHttp.get("Meter/getMeterAllKeyValue?user_type="+(that.$route.query.type||0),{
        project_id:that.project_id,
      },ret=>{
        if(ret.code){
          that.treeDatas=ret.data;
          // that.tree=createTree(0,that.treeDatas);
          typeof callback ==="function"&&callback(ret.data)
        }
      })
    },
    createTree(pid=0){
      this.tree=createTree(pid,this.treeDatas)
    },
    onClick(node){
      this.$emit("onClick",node)
    },
    onCheck(nodes){
      this._checkboxKeys=nodes.map(ret=>ret.id)
      this.$emit("onCheck",nodes)
    },
    closeComponent(){
      this.height2=this.height2!=='40px'?'40px':this.height;
    },
    getCheckedKeys(){
      return this._checkboxKeys
    }
  },
  watch: {
    filterText(val) {
      const that=this;
      that.$refs.ZTreeRef.search(val,true)
    }
  },
}

const createTree = (pid=0,list=[]) => {
  return list.filter(ret=>ret.pid===pid).map(ret=>{
    if(list.findIndex(ret2=>ret2.pid===ret.id)!==-1){
      ret.children=createTree(ret.id,list)
    }
    return ret;
  })
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/MeterTreeComponent.vue